import { useSession } from 'next-auth/react';
import { useInfiniteQuery } from '@tanstack/react-query';

import { getNotiOptions } from '~/features/notifications/queries';

export function useNotifications() {
  const { data: session } = useSession();
  const notiOptions = getNotiOptions({ enabled: !!session });
  const { data } = useInfiniteQuery(notiOptions);

  const notifications = (data?.pages ?? []).flatMap(([noti]) => noti);
  const unreadNotifications = notifications.filter((noti) => !noti.read);

  return {
    notifications,
    unreadNotifications,
  };
}
